import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button, ButtonLink } from '../components/Button';
import { Paper } from '../components/Paper';
import { EmptyState } from '../components/States';
import { CenteredPage } from './CenteredPage';

export function RouteError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  // A failed lazy chunk usually means a new version was deployed.
  const staleChunk =
    error instanceof Error && /dynamically imported module|Importing a module script/i.test(error.message);

  return (
    <CenteredPage>
      <Paper>
        <EmptyState
          title={notFound ? "There's nothing pinned here" : 'Something went wrong'}
          actions={
            staleChunk ? (
              <Button variant="primary" onClick={() => window.location.reload()}>
                Reload Roadrunner
              </Button>
            ) : (
              <ButtonLink to="/" variant="primary">
                Back to the board
              </ButtonLink>
            )
          }
        >
          {staleChunk
            ? 'Roadrunner was updated while you had it open. Reload to get the latest version.'
            : 'Head back to the board and try again.'}
        </EmptyState>
      </Paper>
    </CenteredPage>
  );
}
